export default {
    app:{
        name: 'Наименование',
        search: 'Поиск',
        save: 'Сохранить',
        select:'Выбрать',
        cancel: 'Отмена',
        copy : 'Копировать',
        update: 'Обновить',
        delete: 'Удалить',
        upload: 'Выгрузить',
        download :'Загрузить',
        actions: 'Действия',
        comment: 'Комментарий',
        yes: 'да',
        no: 'нет',
        archiveAction: 'Архивировать',
        date: 'Дата',
        time: 'Время',
        excel:{
            operations:'Операции с Excel'
        }
    }
}